// designer.module.js
import SecureApiService from "../secureapi.service";

export const PULL_DESIGNER_CONFIG = "[get]designer";
export const SAVE_DESIGNER_CONFIG = "[post]designer/draft";
export const PUBLISH_DESIGNER_CONFIG = "[post]designer/publish";
export const REVERT_DESIGNER_CONFIG = "[delete]designer/revert";
export const SET_INFO = "setInfo";
export const DESIGNER_CONFIG = "designer_config";
export const SET_ERROR = "setError";

const state = {
  designer: null,
  loading: false,
  errors: []
};

const getters = {
  getDesigner(state) {
    return state.designer;
  },
  isDesignerLoading(state) {
    return state.loading;
  }
};

const actions = {
  [PULL_DESIGNER_CONFIG](context) {
    state.loading = true;
    return SecureApiService.get("v2/designer")
      .then(({ data }) => {
        context.commit(DESIGNER_CONFIG, data);
      })
      .catch(({ response }) => {
        const errors = response?.data?.errors || [
          "Nepodařilo se načíst konfiguraci designeru."
        ];
        context.commit(SET_ERROR, errors);
      });
  },
  [SAVE_DESIGNER_CONFIG](context, configData) {
    state.loading = true;
    return SecureApiService.post("v2/designer/draft", configData)
      .then(({ data }) => {
        context.commit(DESIGNER_CONFIG, data);
        context.commit(SET_INFO, "Konfigurace byla úspěšně uložena.");
      })
      .catch(({ response }) => {
        const errors = response?.data?.errors || [
          "Nepodařilo se uložit konfiguraci designeru."
        ];
        context.commit(SET_ERROR, errors);
      });
  },
  [PUBLISH_DESIGNER_CONFIG](context, configData) {
    state.loading = true;
    return SecureApiService.post("v2/designer/published", configData)
      .then(({ data }) => {
        context.commit(DESIGNER_CONFIG, data);
        context.commit(SET_INFO, "Konfigurace byla úspěšně uložena.");
      })
      .catch(({ response }) => {
        const errors = response?.data?.errors || [
          "Nepodařilo se uložit konfiguraci designeru."
        ];
        context.commit(SET_ERROR, errors);
      });
  },
  [REVERT_DESIGNER_CONFIG](context) {
    state.loading = true;
    return SecureApiService.delete("v2/designer", "draft")
      .then(({ data }) => {
        context.commit(DESIGNER_CONFIG, data);
        context.commit(SET_INFO, "Konfigurace byla úspěšně obnovena.");
      })
      .catch(({ response }) => {
        const errors = response?.data?.errors || [
          "Nepodařilo se uložit konfiguraci designeru."
        ];
        context.commit(SET_ERROR, errors);
      });
  }
};

const mutations = {
  [DESIGNER_CONFIG](state, data) {
    state.loading = false;
    state.designer = data;
  },
  [SET_ERROR](state, errors) {
    state.loading = false;
    state.errors = errors;
  },
  [SET_INFO](state, message) {
    if (message) {
      state.message = message;
      state.hasMessage = true;
    }
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
